const normalizePrefsPendingMutation = (payload = null) => {
  const path = String(payload?.path || payload?.meta?.path || '').trim();
  const requestId = String(payload?.requestId || payload?.meta?.requestId || '').trim();

  if (!path || !requestId) {
    return null;
  }

  return {
    path,
    requestId,
    value: payload?.value
  };
};

export default normalizePrefsPendingMutation;
